import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'

import CloseButton from './CloseButton'

export default class extends Component {
  constructor (props) {
    super(props)

    this.state = {
      height: Object.keys(props.items).lenght * 18,//0,
      select: (props.value != null) ? props.items[props.value] : props.placeholder,//null
      isOpen: false,
      substring: this.props.sub
    }

    this.handleClick = this.handleClick.bind(this)
    this.selectOption = this.selectOption.bind(this)
  }

  handleClick (e) {
    if (!e || !e.target.viewBox || (e.target.viewBox && e.target.viewBox.animVal.height != 87)) {//если это не очистка значения
      if (this.state.isOpen) {
        document.body.classList.add('hide-dropdown')
        setTimeout(() => {
          this.setState({ isOpen: false })
          document.body.classList.remove('hide-dropdown')
        }, 150)
      } else {
        this.setState({ isOpen: true }, () => {
          this.setState({ height: Object.keys(this.props.items).lenght * 18})//window.innerHeight - (this.body.getBoundingClientRect().top + this.body.getBoundingClientRect().height) })
        })
      }
    }    
  }

  selectOption (e) {
    if (e.target.dataset.option === undefined) {//очистка выбранного варианта
      this.setState({ select: this.props.placeholder }, () => {
        //this.handleClick()
      })
      this.props.onSubmit(null)
    } else {
      this.setState({ select: this.props.items[e.target.dataset.option.toString()] }, () => {
        this.handleClick()
      })
      this.props.onSubmit(e.target.dataset.option.toString())
    }
  }

  componentDidMount () {}

  render () {
    const items = this.props.items
    const newclass = (this.props.class) ? this.props.class : "";
    const scrollclass = (this.props.scrollclass) ? this.props.scrollclass : "Select-scroll";
    const classItem = (this.props.classItem) ? this.props.classItem : "Select-item";

    return (
      <div className={'Select ' + newclass}>
        <div className='Select-body' onClick={this.handleClick} ref={el => { this.body = el }}>
          <span className={this.props.classname ? this.props.classname : 'Select-label'}>{(this.props.value!=null) ? this.props.items[this.props.value] : this.props.placeholder || (<FormattedMessage id='select.subject' />) } {this.state.substring && <span>{this.state.substring}</span>}</span>
          
          {!this.props.required && <CloseButton className='Menu__close Menu__close-select' onClick={this.selectOption} />}  

          {/*!this.state.select && (*/
            <span className='Select-icon'
              style={{
                transform: this.state.isOpen && 'rotate(-180deg)',
                transition: 'transform 200ms ease-out'
              }}
            >
              <svg xmlns='http://www.w3.org/2000/svg' width='41' height='24' viewBox='0 0 41 24'><path fill='rgba(0, 0, 0, .5)' fillRule='evenodd' d='M-.001 3.654l20.167 20.097L40.332 3.654 37.46.749 20.166 18 2.905.749z' /></svg>
            </span>
          /*)*/}
          {this.state.select && <button className='Select__submit Head'>→</button>}
        </div>
        {this.state.isOpen &&
          <div className='Select-list' style={{ height: `${this.state.height}px` }}>
            <ul className={scrollclass}>
              {
                Array.isArray(items)
                ?
                items.map((el, index) => (
                  <li key={`select-item-${index}`} className={classItem + " Select-item_extended"} onClick={el.onClick} data-option={index}>{el.name} {el.sub && <span>{el.sub}</span>}</li>
                ))
                :
                Object.keys(items).map(key => (
                  <li key={key} className={classItem} onClick={this.selectOption} data-option={key}>{items[key]}</li>
                ))
                
              }
            </ul>
          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Select.jsx